<script setup>
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import InboxesAPI from 'dashboard/api/inboxes';
import MercadoLivreAPI from 'dashboard/api/channel/mercadoLivreClient';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({ config: { type: Object, required: true } });
const emit = defineEmits(['update']);
const { t } = useI18n();
const inboxes = ref([]);
const busy = ref(false);
const error = ref(false);
const load = async () => {
  busy.value = true;
  error.value = false;
  try {
    const { data } = await InboxesAPI.get();
    inboxes.value = data.payload.filter(
      i => i.channel_type === 'Channel::MercadoLivre'
    );
  } catch {
    error.value = true;
  } finally {
    busy.value = false;
  }
};
const connect = async () => {
  const tab = window.open('about:blank', '_blank');
  if (!tab) {
    error.value = true;
    return;
  }
  tab.opener = null;
  busy.value = true;
  error.value = false;
  try {
    const { data } = await MercadoLivreAPI.generateAuthorization();
    const url = new URL(data.url);
    if (url.origin !== 'https://auth.mercadolivre.com.br')
      throw new Error('Invalid authorization URL');
    tab.location.href = url.href;
  } catch {
    tab.close();
    error.value = true;
  } finally {
    busy.value = false;
  }
};
onMounted(load);
</script>

<template>
  <div class="space-y-3">
    <label class="block text-sm text-n-slate-12">
      {{ t('MARKETPLACE_CONNECTOR.SELLER') }}
      <select
        :value="config.inbox_id || ''"
        class="mt-1 w-full rounded-lg border border-n-weak bg-n-solid-1 p-2"
        @change="
          emit('update', {
            ...props.config,
            inbox_id: Number($event.target.value) || null,
          })
        "
      >
        <option value="">{{ t('MARKETPLACE_CONNECTOR.SELECT') }}</option>
        <option v-for="inbox in inboxes" :key="inbox.id" :value="inbox.id">
          {{ inbox.name }}
        </option>
      </select>
    </label>
    <p class="text-xs text-n-slate-11">
      {{ t('MARKETPLACE_CONNECTOR.AUTH_HELP') }}
    </p>
    <div class="flex flex-wrap gap-2">
      <Button
        type="button"
        :label="t('MARKETPLACE_CONNECTOR.CONNECT')"
        :disabled="busy"
        @click="connect"
      />
      <Button
        type="button"
        :label="t('MARKETPLACE_CONNECTOR.REFRESH')"
        :is-loading="busy"
        variant="outline"
        @click="load"
      />
    </div>
    <p v-if="error" role="alert" class="text-sm text-n-ruby-11">
      {{ t('MARKETPLACE_CONNECTOR.AUTH_ERROR') }}
    </p>
  </div>
</template>
